import { useMutation } from '@tanstack/react-query'

import { updateSiteActivationOrderSettings } from '@/features/site/endpoints/sites'
import type { SiteActivationOrderSettingsRequest } from '@/features/site/types/site'

export type UseSiteActivationOrderSettingsMutationResult = ReturnType<typeof useSiteActivationOrderSettingsMutation>

export function useSiteActivationOrderSettingsMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { siteUuid: string; location: string; payload: SiteActivationOrderSettingsRequest }) =>
      updateSiteActivationOrderSettings(variables.siteUuid, variables.location, variables.payload),
  })

  return {
    updateSiteActivationOrderSettings: mutateAsync,
    ...mutationResult,
  }
}
